export default {
    get
}

function get(value) {
    switch(value) {
        case 'admin': return 'Administrador'
        case 'card': return 'Tarjeta'
        case 'cash': return 'Efectivo'
        case 'closed': return 'Cerrado'
        case 'creditnote': return 'Nóta de crédito'
        case 'failure': return 'Fallido'
        case 'input': return 'Entrada'
        case 'invoice': return 'Factura'
        case 'lost': return 'Perdido'
        case 'note': return 'Nota'
        case 'open': return 'Abierto'
        case 'output': return 'Salida'
        case 'paid': return 'Pagado'
        case 'pending': return 'Pendiente'
        case 'possible': return 'Posible'
        case 'progress': return 'Progreso'
        case 'review': return 'Revisión'
        case 'success': return 'Completado'
        case 'tracing': return 'Seguimiento'
        case 'transfer': return 'Transferencia'
        case 'win': return 'Ganado'
        case 'charges': return 'Cargos'
        case 'refunds': return 'Reembolsos'
        case 'charge': return 'Cargo'
        case 'refund': return 'Reembolso'
        case 'account': return 'Cuenta'
        case 'wallet': return 'Cartera'
        case 'prepaid': return 'Prepago'
        case 'account': return 'Cuenta'
        case 'scheme': return 'Esquema'
        case 'enabled': return 'Habilitado'
        case 'disabled': return 'Deshabilitado'
        case 'user': return 'Usuario'
        case 'admin': return 'Administrador'
        case 'adviser': return 'Asesor'
        case 'support': return 'Soporte'
        case 'seller': return 'Vendedor'
        case 'shipmentcost': return 'Costo de envío'
        case 'weightadditional': return 'Peso adicional'
        case 'fixedprice': return 'Precio fijo'
        case 'account': return 'Cuenta'
        case 'flat': return 'Flat'
        case 'percent': return 'Porcentaje'
        case 'publico': return 'Público'
        case 'revisión': return 'Revisión'
        case 'seguimiento': return 'Seguimiento'
        case 'finalizado': return 'Finalizado'
        case 'resuelto': return 'Resuelto'
        case 'pricing': return 'Pricing'
        default: return value
    }
}